export default {
  setKnowledgeId({ commit }, knowledgeId) {
    commit('SET_KNOWLEDGE_ID', knowledgeId);
    commit('SET_LINK', null);
  },
  async requestKBOverviewExport({ dispatch, getters, commit }) {
    await this.$services.exportClient.putKBOverviewExport({
      knowledgeId: getters.knowledgeId,
    });
    commit('SET_LINK', null);
    dispatch('triggerPoller');
  },

  triggerPoller({ commit, getters, dispatch }) {
    commit(
      'SET_TIMEOUT',
      setTimeout(async () => {
        dispatch('checkExportStatus');
      }, getters.timeoutTime),
    );
  },

  clearPoller({ commit }) {
    commit('SET_TIMEOUT', null);
    commit('SET_TIMEOUT_TIME', 500);
  },

  setLinkIsAvailable({ commit }, link) {
    commit('SET_LINK', link);
    commit('SET_IS_GENERATING', false)
  },

  async checkExportStatus({ commit, dispatch, getters }) {
    if (!getters.knowledgeId) return;
    commit('SET_IS_GENERATING', true);
    try {
      const result = await this.$services.exportClient.getKBOverviewExport({
        knowledgeId: getters.knowledgeId,
      });
      if (result.state == 'PENDING') {
        commit('SET_TIMEOUT_TIME', Math.min(getters.timeoutTime * 2, 10000));
        dispatch('triggerPoller');
        return
      }
      if (result.state == 'DONE') {
        dispatch('setLinkIsAvailable', result.exportLink);
      }
      dispatch('clearPoller');
    } catch (error) {
      dispatch('clearPoller');
    }
    commit('SET_IS_GENERATING', false);
  },

};
